import { render, staticRenderFns } from "./StockviewMarketDemand.vue?vue&type=template&id=68b09aac&"
import script from "./StockviewMarketDemand.vue?vue&type=script&lang=js&"
export * from "./StockviewMarketDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports